import React from "react";
import { inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import { graphql } from "@apollo/client/react/hoc";
import compileTerms from "Texts/terms";
import { SITE_CONFIG_QUERY } from "Services/queries";
import { BigBlockStub } from "Layouts/Stubs";
import TextBlock from "ComponentsUI/TextBlock";
import Container from "reactstrap/lib/Container";
import { PaddingBottom } from "ComponentsUI/Spacings";
import { Redirect404 } from "ComponentsUI/Redirects";
import { isMainSiteCode, isMoscowSiteCode } from "Utils/siteConfig";

@inject("ApplicationModel")
class Page extends React.Component {
	componentDidMount() {
		const modal = this.props.ApplicationModel.modalModel;
		if (modal.isOpen) {
			modal.toggleModal();
		}
	}

	render() {
		const {
			ApplicationModel: { siteCode, currentRegion },
			match: { params },
		} = this.props;

		if (params?.regionUrl && params?.regionUrl !== currentRegion?.url) {
			return <Redirect404 message404={`Несовпадение regionUrl: ${params?.regionUrl}`} />;
		}

		if (!this.props.data.siteConfig) return <BigBlockStub />;
		let siteConfig = this.props.data.siteConfig;

		return (
			<Container>
				{isMainSiteCode(siteCode) && <div></div>}
				<PaddingBottom>
					<TextBlock
						text={compileTerms(
							siteConfig.domain_name,
							this.props.location.pathname,
							isMoscowSiteCode(siteConfig.code)
								? siteConfig.ssl
									? "https://www."
									: "http://www."
								: siteConfig.ssl
									? "https://"
									: "http://"
						)}
					/>
				</PaddingBottom>
			</Container>
		);
	}
}

export default withRouter(graphql(SITE_CONFIG_QUERY)(Page));
